<template>
    <v-col cols="12" xl="10" class="px-0">
        <v-row>
            <v-col cols="12">
                <h5>{{ t('laboratories::form.title.general_information') }}</h5>
            </v-col>
            <v-col cols="12" lg="6" class="pt-0">
                <b-input
                    to-mutate="laboratories::laboratory.name"
                    :label="t('laboratories::form.label.number')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.accreditation_number"
                    mandatory
                ></b-input>
            </v-col>
            <v-col cols="12" lg="6" class="pt-0">
                <div style="width: max-content" class="pl-2 pl-md-0">
                    <b-switch
                        to-mutate="laboratories::laboratory.is_registered"
                        :label="t('laboratories::form.label.registered')"
                        :readonly="readOnlyRules"
                        :rules="validationRules.is_registered"
                    ></b-switch>
                </div>
            </v-col>
            <v-col cols="12" lg="6" class="pt-0">
                <b-input
                    to-mutate="laboratories::laboratory.prn"
                    :label="t('collection-centre::form.label.prn')"
                    :readonly="readOnlyRules"
                ></b-input>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <h5>{{ t('laboratories::form.title.address') }}</h5>
            </v-col>
            <v-col cols="12" lg="6" class="pt-0">
                <b-input
                    to-mutate="laboratories::laboratory.address"
                    :label="t('laboratories::form.label.address')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.address"
                    mandatory
                ></b-input>
            </v-col>
            <v-col cols="12" lg="6" class="pt-0">
                <b-input
                    to-mutate="laboratories::laboratory.post_code"
                    :label="t('laboratories::form.label.post_code')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.post_code"
                    mandatory
                ></b-input>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <h5>{{ t('laboratories::form.title.contact_details') }}</h5>
            </v-col>
            <v-col cols="12" lg="6" class="py-0">
                <b-input
                    to-mutate="laboratories::laboratory.phone"
                    :label="t('laboratories::form.label.phone')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.phone"
                    mandatory
                ></b-input>
            </v-col>
            <v-col cols="12" lg="6" class="pt-0">
                <b-input
                    to-mutate="laboratories::laboratory.fax"
                    :label="t('laboratories::form.label.fax')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.fax"
                ></b-input>
            </v-col>
            <v-col cols="12" lg="6" class="pt-0">
                <b-input
                    to-mutate="laboratories::laboratory.email"
                    :label="t('laboratories::form.label.email')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.email"
                    mandatory
                ></b-input>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <h5 class="m-0">{{ t('laboratories::form.title.npt_device') }}</h5>
            </v-col>
            <v-col cols="12" lg="6" class="py-0">
                <b-select
                    to-mutate="laboratories::laboratory.npt_device_id"
                    :label="t('laboratories::form.label.npt_device')"
                    :select-items="nptDevicesOptions"
                    :readonly="readOnlyRules"
                    :rules="validationRules.npt_device_id"
                    rounded
                    clearable
                    :hint="t('laboratories::form.npt_device.hint')"
                    persistent-hint
                    component-name="v-autocomplete"
                ></b-select>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
export default {
    data() {
        return {
            readOnlyRules: !this.can('api.v1.collection-centres.update') && this.can('api.v1.collection-centres.show'),
            validationRules: {
                accreditation_number: [(v) => !!v || t('users::validation.field.required')],
                address: [(v) => !!v || t('users::validation.field.required')],
                post_code: [(v) => !!v || t('users::validation.field.required'), this.$root.rules.postCode],
                phone: [(v) => !!v || t('users::validation.field.required'), this.$root.rules.phone],
                fax: [this.$root.rules.fax],
                email: [],
            },
        };
    },
    computed: {
        nptDevicesOptions() {
            return this.$store.state.laboratories.nptDevicesOptions.map((x) => ({ value: x.id, text: x.name }));
        },
    },
};
</script>

<style></style>
